
<style>
.inbound-steps .vview-icons-ios-checkmark-empty::before {
	content: "\F171";
}
</style>

<template>
	<vSteps v-if="getCurIndex>-1" :current="getCurIndex" class="bg-fff padding-20 inbound-steps">
		<vStep v-for="(val,key) of progressStatus" :title="val.name" :key="key"></vStep>
	</vSteps>
</template>

<script>
export default {
	props: ['status', 'type'],
	computed: {
		getCurIndex() {
			return this.progressStatus.findIndex((item) => {
				return item.value == this.status
			})
		},
		progressStatus() {
			const isCancel = this.status == 110;
			const arr = [{
				name: this.$t('fbb.inbound.draft',{defaultValue:'草稿'}),
				value: 0,
				show: true,
			},
            {
				name: this.$t('fbb.inbound.check_pending',{defaultValue:'待审核'}),
				value: 5,
				show: true,
			},
            {
				name: "待出库",
				value: 10,
				show: this.type == 'FBAIn',
			},
            {
				name: "出库中",
				value: 15,
				show: this.type == 'FBAIn',
			},
            {
				name: "待入库",
				value: 20,
				show: this.type == 'FBAOut',
			},
            {
				name: "入库中",
				value: 25,
				show: this.type == 'FBAOut',
			},
            {
				name: this.$t('global.common.finished',{defaultValue:'已完成'}),
				value: 70,
				show: true,
			}]
			return isCancel ? [{
				name: this.$t('global.common.canceled',{defaultValue:'已取消'}),
				value: 110,
			}] : arr.filter(item => item.show)
		}
	}
}
</script>
